// extracted by mini-css-extract-plugin
module.exports = {"image":"jgp-2a-kC","name":"jgp-zMHEM"};